import React from 'react'
import { GetLinkForStripe } from '../../../store/UserClient'

const StripePortalButton = ({ buttonText, isGreen, goToCardInfoPage }) => {
    const Stripe = async () => {
        const redirectUri = await GetLinkForStripe(window.location.href)
        if (redirectUri && redirectUri.data) {
            let redirectLink = redirectUri.data
            if (goToCardInfoPage) {
                redirectLink = `${redirectLink}/payment-methods`
            }

            window.location = redirectLink
        }
    }

    return (
        <button onClick={Stripe} className={isGreen ? 'btn btn-green' : 'btn'}>
            {buttonText || 'UPDATE/CHANGE YOUR PAYMENT INFO'}
        </button>
    )
}

export default StripePortalButton
